import React, { useState } from 'react';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';
import { ElementWrapper, PanelSectionContent } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import usePostStowageApi from 'src/api/stowage/usePostStowageApi';
import { useAuthStore } from 'src/context/AuthContext';
import { createInitialMasterPlan } from 'src/factory/Stowage/StowagePlanFactory';
import OdfjellInputComponent from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import useStowageQueryParamsUtils from 'src/utils/stowage/useStowageQueryParamsUtils';
import { PreviewText } from './CreateInitialMasterPlanPanel.style';

interface CreateInitialMasterPlanPanelProps {
    imoNumber: number;
    vesselName: string;
    defaultVoyageNumber: string;
    onClose: () => void;
}

const CreateInitialMasterPlanPanel: React.FC<CreateInitialMasterPlanPanelProps> = ({ imoNumber, vesselName, defaultVoyageNumber, onClose }) => {
    const { loggedInUser } = useAuthStore();
    const { addStowagePlan } = usePostStowageApi();
    const { setQueryParamStowagePlan } = useStowageQueryParamsUtils();
    const [voyageNumber, setVoyageNumber] = useState(defaultVoyageNumber);

    const titlePreview = `${vesselName} ${voyageNumber}`.trim();
    const isInvalid = voyageNumber.trim() === '';

    const handleCreate = async () => {
        const plan = createInitialMasterPlan(imoNumber, vesselName, voyageNumber.trim(), loggedInUser.fullName);
        const { updatedStowagePlan } = await addStowagePlan(plan);
        if (updatedStowagePlan) {
            setQueryParamStowagePlan(updatedStowagePlan.stowagePlanGuid, ['portCallGuid', 'berthCallGuid', 'cargoOperationGuid']);
        }
        onClose();
    };

    return (
        <OdfjellPanel
            headerTitle="Create Initial Master Plan"
            defaultPosition="center"
            preventOutsideClose={true}
            hasCurtain={true}
            panelWidth={PANEL_CONSTANTS.MEDIUM_WIDTH}
            onAction={handleCreate}
            actionButtonText="Create"
            showCancelButton={true}
            onCancel={onClose}
            isActionDisabled={isInvalid || !loggedInUser}
        >
            <PanelSectionContent>
                <ElementWrapper>
                    <label>
                        <strong>Vessel</strong>
                    </label>
                    <div>{vesselName}</div>
                </ElementWrapper>
                <ElementWrapper>
                    <OdfjellInputComponent
                        description="Voyage number"
                        type="text"
                        isReadOnly={false}
                        value={voyageNumber}
                        onChange={(e) => setVoyageNumber(e.event.target.value)}
                    />
                </ElementWrapper>
                <ElementWrapper>
                    <label>
                        <strong>Plan title preview</strong>
                    </label>
                    <PreviewText>{titlePreview || '—'}</PreviewText>
                </ElementWrapper>
            </PanelSectionContent>
        </OdfjellPanel>
    );
};

export default CreateInitialMasterPlanPanel;
